(function () {
  'use strict';

  angular.module('app.measure', ['daterangepicker'])

    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
      $stateProvider
        .state('home.measure', {
          requireLogin: true,
          url: 'measure',
          templateUrl: 'app/measure/measure.html?app_v=deployDate',
          data: {
            authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
            navMarker: ['measure', 'index']
          },
          controller: 'MeasureCtrl',
          controllerAs: 'vm'
        })
    }])

    .directive('htmlRender', function($compile) {
      return {
        restrict: 'E',
        scope: { 
          html: '@'
        },
        link: function(scope, element) {
          scope.$watch('html', function(value) {
            if (!value || value === undefined) return;
            
            var markup = null;
            markup = $compile(value)(scope);
            element.append(markup)
          });
        }
      };
    })

})();